import React, { useState } from 'react';
import {
  Box,
  Button,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useNavigate } from 'react-router-dom';


import AccessTimeIcon from '@mui/icons-material/AccessTime';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';


import ShareReport from '../../../components/Projects/ShareReport';
import ScheduleReport from '../../../components/Projects/ScheduleReport';

import ExportFile from '../../../pages/report/app-url-report/ExportFile';

import TimeActiveFilter from '../../report/time-activity/TimeActiveFilter';
import TableDownloadBtn from '../../../components/dropdown-select/TableDownloadBtn';



import WidgetsDropdown from '../../../layout/WidgetsDropdown';
import MonthlyBarChart from '../MonthlyBarChart';
import MemberActivityTable from '../../../components/ReportsMemberActivity/MemberActivityTable';
import ProjectActivityTable from '../../../components/ReportsProjectActivity/ProjectActivityTable';
import DateActivityTable from '../../../components/ReportsDateActivity/DateActivityTable';
import { FilterwIcon, ExportIcon, OrganizeIcon, ShareIcon, ScheduleIcon } from '../../../icons';
import OrganizeBySection from '../../../components/ReportsOrganizeBy/OrganizeBySection';
import DateRangePicker from '../../../components/Date-range-picker/DateRangePicker';
import SummaryList from '../SummaryList';





function CustomTabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const organizeOptions = ['Date', 'Project', 'Member'];

const TimeActivity = () => {
  const navigate = useNavigate();
  const [value, setValue] = useState(0); // Tab value
  const isMeView = value === 0
  const [anchorEl, setAnchorEl] = useState(null); // Menu anchor
  const [selectedOption, setSelectedOption] = useState('Date'); // Organize by

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (option) => {
    setSelectedOption(option);
    setAnchorEl(null);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const renderActivityComponent = () => {
    switch (selectedOption) {
      case 'Project':
        return <ProjectActivityTable isMeView={isMeView} />;
      case 'Member':
        return <MemberActivityTable />;
      case 'Date':
      default:
        return (
          <>
            <DateActivityTable />
            <DateActivityTable />
          </>
        );
    }
  };

  const [openShareReport, setOpenShareReport] = useState(false);
  const [openScheduleReport, setOpenScheduleReport] = useState(false);

  return (
    <>

     
      <Box>
        <Button
          onClick={() => navigate('/reports')}
          style={{
            color: '#1A1F36',
            fontSize: '24px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            marginBottom: '24px',
            textTransform: 'capitalize',
            padding: '0',
            marginLeft: '-10px'
          }}
        >
          <KeyboardArrowLeftIcon
            sx={{ color: '#1760EC', width: '30px', height: '30px' }}
          />
          Reports
        </Button>
      </Box>

      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6" fontWeight="600" sx={{ fontSize: '17px' }}>
          Time and activities reports
        </Typography>
        <Box className="d-flex gap-10 align-items-center">
          {/* Widgets & Scheduled Button */}
          <WidgetsDropdown
            widgetOptions={[
              'Member',
              'Info',
              'Employment',
              'Project',
              'Time',
              'Activity',
              'Manual hours',
              'Idle (%)',
              'Idle (hr)',
              'Spent',
              'Notes',
            ]}
            defaultSelected={[
              'Employment',
              'Project',
              'Time',
              'Activity',
              'Manual hours',
              'Idle (%)',
            ]}
          />
          <Button
            variant="contained"
            sx={{
              borderRadius: '30px',
              textTransform: 'capitalize',
              fontSize: '16px',
              padding: '3px 20px',
              background: '#0076FE',
            }}
            onClick={() => navigate('/scheduled-reports')}
          >
            Scheduled reports
          </Button>
        </Box>
      </Box>

      {/* Tabs */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'inline-block' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Me" {...a11yProps(0)} />
          <Tab label="All" {...a11yProps(1)} />
        </Tabs>
      </Box>

      <Box className="mt-24" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
        <DateRangePicker />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {/* <Button component="label" variant="contained" sx={{ borderRadius: '50px', fontSize: '14px', background: '#0076FE', border: '1px solid #0076FE', color: '#fff', boxShadow: 'none',}}
            tabIndex={-1} startIcon={<FilterwIcon />}>
            Filter
          </Button> */}
          <TimeActiveFilter />


          <Button onClick={() => setOpenShareReport(true)} component="label" variant="contained" sx={{ borderRadius: '50px', fontSize: '14px', background: '#fff', border: '1px solid #E5E8EB', color: '#64748B', boxShadow: 'none', }}
            tabIndex={-1} startIcon={<ShareIcon />}>
            Share
          </Button>

          <Button onClick={() => setOpenScheduleReport(true)} component="label" variant="contained" sx={{ borderRadius: '50px', fontSize: '14px', background: '#fff', border: '1px solid #E5E8EB', color: '#64748B', boxShadow: 'none', }}
            tabIndex={-1} startIcon={<ScheduleIcon />}>
            Schedule
          </Button>

          {/* <Button component="label" variant="contained"
            sx={{ borderRadius: '50px', fontSize: '14px', background: '#fff', border: '1px solid #E5E8EB', color: '#64748B', boxShadow: 'none',}}
            tabIndex={-1} startIcon={<ExportIcon />}>
            Export
          </Button> */}
          <ExportFile />
          {/* <TableDownloadBtn /> */}

        </Box>
        <ShareReport open={openShareReport} onClose={() => setOpenShareReport(false)} />
        <ScheduleReport open={openScheduleReport} onClose={() => setOpenScheduleReport(false)} />

      </Box>

      <Box className="mt-24"><SummaryList showLabels={
        value === 0
          ? [
            'Total Worked Time',
            'Avg. Activity',
            'Total Idea time',
            'Total earned',
          ]
          : [
            'Member',
            'Total Worked Time',
            'Avg. Activity',
            'Total Spent',
          ]
      } /></Box>

      <Box className="card-body p-20 bg-base border rounded-3 mt-24">
        <MonthlyBarChart />
      </Box>


      {/* Me Tab */}
      <CustomTabPanel value={value} index={0}>
        <Box className="mt-24">
          <OrganizeBySection
            anchorEl={anchorEl}
            selectedOption={selectedOption}
            handleOpenMenu={handleOpenMenu}
            handleCloseMenu={handleCloseMenu}
            handleMenuItemClick={handleMenuItemClick}
            organizeOptions={['Date', 'Project']}
          /></Box>

        <Box mt={2}>
          {renderActivityComponent()}
        </Box>
      </CustomTabPanel>

      {/* All Tab */}
      <CustomTabPanel value={value} index={1}>
        <Box className="mt-24">
          <OrganizeBySection
            anchorEl={anchorEl}
            selectedOption={selectedOption}
            handleOpenMenu={handleOpenMenu}
            handleCloseMenu={handleCloseMenu}
            handleMenuItemClick={handleMenuItemClick}
            organizeOptions={['Date', 'Project', 'Member']}
          /></Box>

        <Box mt={2}>
          {renderActivityComponent()}
        </Box>
      </CustomTabPanel>
    </>
  );
};

export default TimeActivity;
